import MicroModal from 'micromodal'

export default {
  install(Vue) {
    Vue.prototype.$modal = {
      show(id, option = {}) {
        const config = Object.assign({}, option, {
          disableFocus: true
        })
        MicroModal.show(id, config)
      },
      close(id) {
        MicroModal.close(id)
      }
    }
  }
}
